import { render, staticRenderFns } from "./AppointmentHeaderRow.vue?vue&type=template&id=5b63a2ba&scoped=true&"
import script from "./AppointmentHeaderRow.vue?vue&type=script&lang=js&"
export * from "./AppointmentHeaderRow.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentHeaderRow.vue?vue&type=style&index=0&id=5b63a2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63a2ba",
  null
  
)

export default component.exports